export default function FeaturedHoliday({ children }) {
  return <div className="featured-holiday">{children}</div>;
}
